// 项目招商
import { getHouseList, getBusinessList, getBusinessDetail } from '@/api'

export default {
	namespaced: true,
	state: {
		houseList: [],
		houseListTotal: 0,
		businessList: [],
		businessListTotal: 0,
		businessDetail: {
			title: '',
		},
	},
	mutations: {
		// 房源信息
		setHouseList(state, payload) {
			if (Array.isArray(payload.list) && payload.list.length > 0) {
				state.houseList = payload.list
				state.houseListTotal = payload.total
			}
		},
		setBusinessList(state, payload) {
			if (Array.isArray(payload.list) && payload.list.length > 0) {
				state.businessList = payload.list
				state.businessListTotal = payload.total
			}
		},
		setBusinessDetail(state, payload) {
			state.businessDetail = payload
		},
	},
	actions: {
		fetchHouseList({ commit }, { page, limit } = { page: 1, limit: 10 }) {
			getHouseList(page, limit).then((result) => {
				commit('setHouseList', result)
			})
		},
		fetchHouseDetail() {
			// getHouseDetail().then((result) => {
			// 	console.log(result)
			// })
		},
		fetchBusinessList(
			{ commit },
			{ page, limit } = { page: 1, limit: 10 }
		) {
			getBusinessList(page, limit).then((result) => {
				commit('setBusinessList', result)
			})
		},
		fetchBusinessDetail({ commit }, payload) {
			getBusinessDetail(payload.id).then((result) => {
				commit('setBusinessDetail', result)
			})
		},
	},
}
